import React, { useEffect } from "react";
import { Modal, Form, Input, Row, Col } from "antd";

const EditRecordModal = ({
  visible,
  onCancel,
  onSave,
  record,
  visibleFields,
}) => {
  const [form] = Form.useForm();
  useEffect(() => {
    if (record) {
      form.setFieldsValue(record);
    }
  }, [record, form]);

  return (
    <Modal
      title="Edit Record"
      visible={visible}
      onCancel={onCancel}
      okButtonProps={{
        form: "editForm",
        htmlType: "submit",
      }}
    >
      <Form id="editForm" form={form} onFinish={onSave}>
        <Row gutter={[16, 16]}>
          {visibleFields.property_number && (
            <Col span={12}>
              <Form.Item label="P-Number" name="property_number">
                <Input />
              </Form.Item>
            </Col>
          )}

          {visibleFields.name && (
            <Col span={12}>
              <Form.Item label="Name" name="name">
                <Input />
              </Form.Item>
            </Col>
          )}
          {visibleFields.email && (
            <Col span={12}>
              <Form.Item label="Email" name="email">
                <Input />
              </Form.Item>
            </Col>
          )}
          {visibleFields.phone && (
            <Col span={12}>
              <Form.Item label="Phone" name="phone">
                <Input />
              </Form.Item>
            </Col>
          )}
          {visibleFields.country_code && (
            <Col span={12}>
              <Form.Item label="Country Code" name="country_code">
                <Input />
              </Form.Item>
            </Col>
          )}
          {visibleFields.mobile_number && (
            <Col span={12}>
              <Form.Item label="Mobile Number" name="mobile_number">
                <Input />
              </Form.Item>
            </Col>
          )}
          {visibleFields.plot_number && (
            <Col span={12}>
              <Form.Item label="Plot Number" name="plot_number">
                <Input />
              </Form.Item>
            </Col>
          )}
          {visibleFields.flat_number && (
            <Col span={12}>
              <Form.Item label="Flat Number" name="flat_number">
                <Input />
              </Form.Item>
            </Col>
          )}
          {visibleFields.floor && (
            <Col span={12}>
              <Form.Item label="Floor" name="floor">
                <Input />
              </Form.Item>
            </Col>
          )}
          {visibleFields.parking_number && (
            <Col span={12}>
              <Form.Item label="Parking Number" name="parking_number">
                <Input />
              </Form.Item>
            </Col>
          )}
          {visibleFields.common_area && (
            <Col span={12}>
              <Form.Item label="Common Area" name="common_area">
                <Input />
              </Form.Item>
            </Col>
          )}
          {visibleFields.actual_area && (
            <Col span={12}>
              <Form.Item label="Actual Area" name="actual_area">
                <Input />
              </Form.Item>
            </Col>
          )}
          {visibleFields.municipality_number && (
            <Col span={12}>
              <Form.Item label="Municipality Number" name="municipality_number">
                <Input />
              </Form.Item>
            </Col>
          )}
          {visibleFields.secondary_mobile && (
            <Col span={12}>
              <Form.Item label="Secondary Mobile" name="secondary_mobile">
                <Input />
              </Form.Item>
            </Col>
          )}
          <Col span={12}>
            <Form.Item label="Comment" name="note">
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditRecordModal;
